export const SECTIONS = [
    {
        id: 'home',
        chapter: 'I',
        label: 'College Finder',
        kicker: 'Chapter One',
        subtitle: 'A folio for the well-prepared.',
        color: '#B79CFF',
    },
    {
        id: 'exam-prep',
        chapter: 'II',
        label: 'Exam Prep',
        kicker: 'Chapter Two',
        subtitle: 'Syllabus, dissected & annotated.',
        color: '#E0A8A8',
    },
    {
        id: 'quizzes',
        chapter: 'III',
        label: 'Timed Quizzes',
        kicker: 'Chapter Three',
        subtitle: 'Practice under pressure.',
        color: '#F0D28A',
    },
    {
        id: 'journal',
        chapter: 'IV',
        label: 'Study Journal',
        kicker: 'Chapter Four',
        subtitle: 'Daily rituals of the disciplined.',
        color: '#A8C69A',
    },
];
